import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initGrowthSliders = () => {
  const slidersContainer = document.querySelector("[data-growth-sliders]");
  if (!slidersContainer) return;

  const reviewsSliders = slidersContainer.querySelectorAll("[data-growth-slider]");

  reviewsSliders.forEach(slider => {
    new Swiper(slider, {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchSlidesProgress: true,
      spaceBetween: 20,
      lazy: true,
      breakpoints: {
        751: {
          slidesPerView: 3,
        },       
        0: {
          slidesPerView: 1,
        },
      },
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "fraction",
      },
      navigation: {
        nextEl: slider.querySelector(".slider-navigation__button--next"),
        prevEl: slider.querySelector(".slider-navigation__button--prev"),
      },
    });
  })
};

export default initGrowthSliders;
